'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var ColorContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  position: relative;\n  &:before {\n    position: absolute;\n    left: 0px;\n    top: -1px;\n    background-color: ", ";\n    border-style: none;\n    border-radius: 1.5px;\n    width: 3px;\n    height: 37px;\n    content: '';\n  }\n\n  padding-left: 0.8rem;\n"], ["\n  position: relative;\n  &:before {\n    position: absolute;\n    left: 0px;\n    top: -1px;\n    background-color: ", ";\n    border-style: none;\n    border-radius: 1.5px;\n    width: 3px;\n    height: 37px;\n    content: '';\n  }\n\n  padding-left: 0.8rem;\n"])), function (props) { return props.color || 'black'; });
var templateObject_1;

exports.ColorContainer = ColorContainer;
